import React, { Component } from 'react';
import Form from '../../components/react-validation/components/form';
import Submit from '../../components/react-validation/components/submit';
import Input from '../../components/react-validation/components/input';
import Textarea from '../../components/react-validation/components/text-area';
import { Modal } from 'react-bootstrap';
import * as Vali from '../../helper/validator-helper';
import PropTypes from 'prop-types';
import * as ModelActionType from '../constants';
export class EditModel extends Component {
  static propTypes = {
    isOpenFormEdit: PropTypes.bool,
    isCreate: PropTypes.bool,
    show: PropTypes.bool,
    title: PropTypes.string,
    onSubmit: PropTypes.func,
    onCloseModal: PropTypes.func,
    item: PropTypes.object,
    errorMsg: PropTypes.array
  }
  constructor(props) {
    super(props);
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.errorMsg.length > 0) {
      if (this.form) {
        this.form.showError(this.refs['name'], nextProps.errorMsg[0].error);
      }
    }
  }

  onCloseModal = () => {
    this.props.onCloseModal();
  }

  onSubmit(e) {
    this.props.onSubmit(e, this.form.getValues(),
      ModelActionType.UPDATE_MODEL_ASYNC, true);

    e.preventDefault();
  }

  render() {
    let { name, code, note } = this.props.item;
    if (this.form) {
      name = this.form.getValues().name;
      code = this.form.getValues().code;
      note = this.form.getValues().note;
    }
    return (
      <Modal show={this.props.isOpenFormEdit}>
        <Modal.Header>
          <Modal.Title id='contained-modal-title-lg'>Edit plan</Modal.Title>
          <button className='close' onClick={this.onCloseModal} >&times;</button>
        </Modal.Header>
        <Form ref={c => { this.form = c; }} onSubmit={this.onSubmit.bind(this)}>
          <Modal.Body>
            <Input type='hidden' name='id' ref='id' value={this.props.item.id} />
            <Input type='hidden' name='projectId' ref='projectId' value={this.props.item.projectId} />
            <div className='form-group'>
              <label>Plan name <span className='text-danger'>*</span></label>
              <Input type='text'
                autoFocus
                name='name'
                ref='name'
                value={name}
                placeholder='Plan name'
                className='form-control'
                max='200'
                maxlength='200'
                validations={[Vali.required, Vali.maxlength]} />
            </div>
            <div className='form-group'>
              <label>Plan code</label>
              <Input type='text'
                name='code'
                ref='code'
                value={code}
                placeholder='Plan code'
                className='form-control'
                max='200'
                maxlength='200'
                validations={[Vali.maxlength]} />
            </div>
            <div className='form-group'>
              <label>Note</label>
              <Textarea
                name='note'
                ref='note'
                value={note}
                placeholder='Note'
                className='form-control'
                max='200'
                maxlength='200'
                validations={[Vali.maxlength]} />
            </div>
          </Modal.Body>
          <Modal.Footer >
            <button type='button' className='btn btn-siteone-default cancel-btn' onClick={this.onCloseModal}>Cancel</button>
            <Submit className='btn btn-primary btn-siteone'>Done</Submit>
          </Modal.Footer>
        </Form>
      </Modal>
    );
  }
}



// WEBPACK FOOTER //
// ./src/Model/Containers/edit-model.js